export default () => ({
	show_main: true,
	show_positive: false,
	show_negative: false,
	setActive(index) {
		if (index <= 3) {
			for (let i = 1; i <= index; i++) {
				const star = document.querySelector(`[data-index="${i}"]`);
				star.classList.add('active-red');
			}
			setTimeout(() => {
				this.show_negative = true;
			}, 300);
		} else {
			for (let i = 1; i <= index; i++) {
				const star = document.querySelector(`[data-index="${i}"]`);
				star.classList.add('active-green');
			}
			setTimeout(() => {
				this.show_positive = true;
			}, 300);
		}

		setTimeout(() => {
			this.show_main = false;
		}, 200);
	},
});
